var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3409_3535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1111 6.00574H22.0733C21.4667 4.3318 19.8778 3.11963 18 3.11963C16.1222 3.11963 14.5333 4.3318 13.9267 6.00574H7.88889C6.3 6.00574 5 7.30449 5 8.89185V29.0946C5 30.682 6.3 31.9808 7.88889 31.9808H28.1111C29.7 31.9808 31 30.682 31 29.0946V8.89185C31 7.30449 29.7 6.00574 28.1111 6.00574ZM18 6.00574C18.7944 6.00574 19.4444 6.65512 19.4444 7.4488C19.4444 8.24248 18.7944 8.89185 18 8.89185C17.2056 8.89185 16.5556 8.24248 16.5556 7.4488C16.5556 6.65512 17.2056 6.00574 18 6.00574ZM20.8889 26.2085H10.7778V23.3224H20.8889V26.2085ZM25.2222 20.4363H10.7778V17.5502H25.2222V20.4363ZM25.2222 14.6641H10.7778V11.778H25.2222V14.6641Z",
    fill: "#255986"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7778,
    y: 11.7861,
    width: 14.4444,
    height: 2.88889,
    fill: "#64C1B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7778,
    y: 17.564,
    width: 14.4444,
    height: 2.88889,
    fill: "#64C1B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7778,
    y: 23.3418,
    width: 10.1111,
    height: 2.88889,
    fill: "#64C1B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3409_3535",
    x: 0,
    y: 0.119629,
    width: 36,
    height: 38.8613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.34902 0 0 0 0 0.52549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3409_3535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3409_3535",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalData);
export default __webpack_public_path__ + "static/media/clinical-data.fc18fb12d368956dfd97a1f4743341bc.svg";
export { ForwardRef as ReactComponent };